import "./PopUp.css"
import EDDiv from "dom/elements/EDDiv.js"

export default class PopUp extends EDDiv {

    show(pModule) {

        window.document.body.classList.add("ed-scroll-block")
        this.container.children.unrender()
        this.container.children.append(pModule)
        this.classList.remove("ed-hidden")
    }

    hide() {

        window.document.body.classList.remove("ed-scroll-block")
        this.classList.add("ed-hidden")
        this.container.children.unrender()
    }

    constructor(p) {

        super(p)
        this.analytics = p.analytics
        this.classList.add("ed-app-popup")
        this.classList.add("ed-hidden")

        this.children.append([
            new EDDiv({
                store: (pEl) => {
                    this.container = pEl
                },
                class: "ed-popup-container"
            })
        ])

        window.addEventListener("popUpEvent", (pEvt) => {

            if(pEvt.detail.cmd === "show") {

                this.show(pEvt.detail.module)
                return
            }
            
            this.hide()
        })
    }
}